import { CButton, CCard, CCardBody, CCol, CForm, CInputGroup, CRow } from '@coreui/react'
import React, { useEffect, useRef, useState } from 'react'
import BaseListing from 'src/BaseListings'
import { wtApiCall } from '../../helpers/commons/ApiWrapper'
import { lzNotifyErrorMessageFromResult } from '../../helpers/commons/notifications'
import jsPDF from 'jspdf'
import 'jspdf-autotable'
import moment from 'moment'
// import DataReportTable from './DataReportTable'
import LeaveReportDataTable from './LeaveReportDataTable'

import Loading from 'src/helpers/commons/loader'
import WidgetSelector from 'src/widgets/Selectors/WidgetSelector'
import { useDownloadExcel } from 'react-export-table-to-excel'
import { JobTypeOptions, YesNoOptions } from 'src/helpers/commons/dropdownOptions'
import AttendanceReportLegends from 'src/widgets/Legends/AttendanceReportLegends'
import { wtRoundNumberToSpecifedDigits } from 'src/helpers/commons/utils'
import WidgetDepartmentSelector from '../../widgets/Selectors/WidgetDepartmentSelector'
import WidgetDesignationSelector from '../../widgets/Selectors/WidgetDesignationSelector'
import { DatePicker } from 'antd'
import WidgetBranchSelector from 'src/widgets/Selectors/WidgetBranchSelector'
const { RangePicker } = DatePicker
export default function OvertimeReport() {
  const Base = new BaseListing()
  const tableRef = useRef(null)
  const [isLoading, setIsLoading] = useState(false)
  const [Employees, setEmployees] = useState([])
  const [Months, setMonths] = useState([])
  const [month, setMonth] = useState(0)
  const [Years, setYears] = useState([])
  const [year, setYear] = useState(0)
  const [isOfficer, setIsOfficer] = useState(null)
  const [branches, setBranches] = useState([])
  const [errors, setErrors] = useState([])
  const [reportData, setReportData] = useState([])
  const [leaveTypeData, setLeaveTypeData] = useState([])
  const [dates, setDates] = useState([])
  const [departments, setDepartments] = useState([])
  const [department_id, setDepartmentId] = useState(0)
  const [department_name, setDepartmentName] = useState('')
  const [range, setRange] = useState(null)
  const [designations, setDesignations] = useState([])
  const [designation_id, setDesignationId] = useState(0)
  const [designation_name, setDesignationName] = useState('')
  const [isMore, setIsMore] = useState(false)
  const [JobType, setJobType] = useState('')
  const [ResignationStatus, setResignationStatus] = useState(0)
  const [branchId, setBranchId] = useState(0)
  const [branch_name, setBranchName] = useState('')

  const RESIGNATION_STATUS_ACTIVE = 0;
  const RESIGNATION_STATUS_RESIGNED = 1;
  const RESIGNATION_STATUS_TERMINATE = 2;
  const RESIGNATION_STATUS_DISCONTINUATION_OF_CONTRACT = 3;
  const RESIGNATION_STATUS_RETIREMENT = 4;
  const RESIGNATION_STATUS_IN_SERVICE_DEATH = 5;

  const RESIGNATION_STATUS_NAME = {
    0: 'Active',
    1: 'Resigned',
    2: 'Terminated',
    3: 'Contract Discontinued',
    4: 'Retired',
    5: 'Passed Away',
  };

  const RESIGNATION_STATUS_DROPDOWN_OPTIONS = [
    { value: RESIGNATION_STATUS_ACTIVE, label: RESIGNATION_STATUS_NAME[RESIGNATION_STATUS_ACTIVE] },
    { value: RESIGNATION_STATUS_RESIGNED, label: RESIGNATION_STATUS_NAME[RESIGNATION_STATUS_RESIGNED] },
    { value: RESIGNATION_STATUS_TERMINATE, label: RESIGNATION_STATUS_NAME[RESIGNATION_STATUS_TERMINATE] },
    { value: RESIGNATION_STATUS_DISCONTINUATION_OF_CONTRACT, label: RESIGNATION_STATUS_NAME[RESIGNATION_STATUS_DISCONTINUATION_OF_CONTRACT] },
    { value: RESIGNATION_STATUS_RETIREMENT, label: RESIGNATION_STATUS_NAME[RESIGNATION_STATUS_RETIREMENT] },
    { value: RESIGNATION_STATUS_IN_SERVICE_DEATH, label: RESIGNATION_STATUS_NAME[RESIGNATION_STATUS_IN_SERVICE_DEATH] },
  ];

  const generatePDF = () => {
    const doc = new jsPDF({ orientation: 'l' }); // Landscape mode
    const logo = 'assets/wil-icon.png';
    const img = new Image();
    var totalPagesExp = '{total_pages_count_string}';
    let yPosition = 49;

    const pageWidth1 = doc.internal.pageSize.width;
    doc.setTextColor('#3c4b64');
    doc.setFont('Helvetica', 'bold');
    doc.setFontSize(14);

    // Table Header
    const headRows = [
      { content: 'Sr' },
      { dataKey: 'id', content: 'ID' },
      { dataKey: 'full_name', content: 'Full Name' },
      { dataKey: 'designation.name', content: 'Designation' },
      { dataKey: 'department.name', content: 'Department' },
    ];

    // Dynamically Add Leave Columns
    leaveTypeData.forEach((item) => {
      headRows.push({
        dataKey: item.leave_name,
        content: item.name,
      });
    });

    // Total Leaves Column
    headRows.push({ dataKey: 'total_leaves', content: 'Total Leaves' });

    // Table Body
    const employeeDetails = reportData.map((employee, index) => [
      index + 1,
      { content: employee.employee_id, styles: { textColor: 'black' } },
      {
        content: `${employee.first_name} ${employee.last_name}`,
        styles: { textColor: '#0000FF', halign: 'left' },
      },
      { content: employee.designation_name, styles: { halign: 'left' } },
      { content: employee.department_name, styles: { halign: 'left' } },
      ...leaveTypeData.map(type => ({
        content: employee[type.leave_name] || "0",
        styles: { halign: "center" }
      })),
      { content: employee.total_leaves, styles: { textColor: '#0000FF' } }

    ]);

    // Generate Table
    doc.autoTable({
      head: [headRows],
      body: employeeDetails,
      startY: 40.5,
      margin: { top: 50, bottom: 20, left: 5, right: 5 },
      theme: 'plain',
      styles: { lineColor: '#3c4b64', lineWidth: 0.2, halign: 'center' },
      headStyles: {
        fillColor: '#fff',
        textColor: [60, 75, 100],
        font: 'helvetica',
      },
      columnStyles: {
        0: { cellWidth: 10 },  // Sr No
        1: { cellWidth: 10 },  // ID
        2: { cellWidth: 40 },  // Full Name
        3: { cellWidth: 40 },  // Designation
        4: { cellWidth: 40 },  // Department
      },
      didDrawPage: function (data) {
        let pageNo = doc.internal.getNumberOfPages();
        var pageSize = doc.internal.pageSize;
        var pageHeight = pageSize.height;
        var pageWidth = pageSize.width;

        doc.setTextColor('#3c4b64');
        doc.setFont('Helvetica', 'bold');

        // Header Logo
        doc.addImage(logo, 'PNG', 20, 4, 25, 25);
        doc.line(47, 7, 47, 27);
        doc.setFontSize(11);
        doc.text('WAH', 50, 10, { align: 'left' });
        doc.text('INDUSTRIES', 50, 15);
        doc.text('LIMITED', 50, 20);
        doc.text('www.wahindustries.com', 50, 25);

        doc.setFontSize(14);
        doc.text('Employee Leave Report', pageWidth - 20, 10, { align: 'right' });

        // Page No
        var str = 'Page ' + pageNo;
        if (typeof doc.putTotalPages === 'function') {
          str += ' of ' + totalPagesExp;
        }

        doc.setTextColor('black');
        doc.text(str, 10, pageHeight - 4);
      },
    });
    // Footer
    doc.setFontSize(10);
    const printReport =
      'This Report is printed through ERP at ' + moment().format('YYYY-MM-DD HH:mm:ss');
    const pageWidth = doc.internal.pageSize.width;
    const textWidth =
      (doc.getStringUnitWidth(printReport) * doc.internal.getFontSize()) / doc.internal.scaleFactor;
    const startXForPrintReport = (pageWidth - textWidth) / 2;
    const startYForPrintReport = doc.autoTable.previous.finalY + 20;

    doc.text(printReport, startXForPrintReport, startYForPrintReport, { halign: 'center' });

    doc.setTextColor('#3c4b64');
    doc.setFontSize(9);
    if (typeof doc.putTotalPages === 'function') {
      doc.putTotalPages(totalPagesExp);
    }

    doc.save('LeaveReport.pdf');
  };


  const { onDownload } = useDownloadExcel({
    currentTableRef: tableRef.current,
    filename: 'Leave Report',
    sheet: 'sheet',
  })

  const changeValues = (key, val) => {
    if (key === 'department_id') {
      setDepartmentId(val.value)
      setDepartmentName(val.label)
    }
    if (key === 'designation_id') {
      setDesignationId(val.value)
      setDesignationName(val.label)
    }
    // if (key === 'employee_id') {
    //   setEmployeeId(val.value)
    //   setEmployeeName(val.label)
    // }
    if (key === 'resignation_status') {
      setResignationStatus(val.value)
    }
    if (key === 'branch_id') {
      setBranchId(val.value)
      setBranchName(val.label)
    }
  }

  const getReportData = () => {
    // Check if range is not null and has at least two elements
    if (range && range.length >= 2) {
      const fromDate = range[0]
      const toDate = range[1]

      setIsLoading(true)
      wtApiCall(
        'reports/employee_leave_report',
        {
          fromDate: fromDate.format('YYYY-MM-DD'),
          toDate: toDate.format('YYYY-MM-DD'),
          month: month,
          year: year,
          // is_officer: isOfficer,
          designation_id: designation_id,
          department_id: department_id,
          resignation_status: ResignationStatus,
          job_status: JobType,
          parent_branch_id: branchId,

        },
        'get',
        (response) => {
          const { data } = response
          setReportData(data.data)
          setLeaveTypeData(data.leave_types)
          setDates(data.dates)
          setIsLoading(false)
        },
        (error) => {
          lzNotifyErrorMessageFromResult(error)
          setIsLoading(false)
        },
      )
    } else {
      alert('Please select a valid date range.')
    }
  }

  useEffect(() => {
    Base.dropdownData(
      'employees,branches,designations,attendance_months,attendance_years,departments',
      {},
      [setEmployees, setBranches, setDesignations, setMonths, setYears, setDepartments],
      1,
    )
  }, [])
  return (
    <>
      <div style={{ padding: '2%' }}>
        <center>
          <h4>Employee Leave Report</h4>
        </center>
        <CRow style={{ width: '100%' }}>
          <CCol md={12}>
            <CCard className="card-dark">
              <CCardBody style={{ backgroundColor: '#f7f9fa' }}>
                <br />
                <CForm>
                  <CRow>
                    {/* <CCol md={1}></CCol> */}
                    <CCol md={1}>
                      <CInputGroup>
                        <label style={{ fontSize: '140%', marginTop: '50px' }}>Filters:</label>
                      </CInputGroup>
                    </CCol>
                    <CCol md={3}>
                      <div className="form-group">
                        <label>Date Range:</label>
                        <br />
                        <RangePicker value={range} onChange={setRange} size="middle" />
                      </div>
                    </CCol>
                    <CCol md={3}>
                      <CInputGroup>
                        <label>Department</label>
                        <WidgetDepartmentSelector
                          departments={departments}
                          displayValue={department_name}
                          value={department_id}
                          placeholder="Select Department"
                          onChange={(values) => changeValues('department_id', values)}
                          reloadDropdownData={() =>
                            Base.dropdownData('departments', {}, [setDepartments], 1)
                          }
                        />
                        {errors.department_id && <ErrorMessage messages={errors.department_id} />}
                      </CInputGroup>
                    </CCol>

                    {/* <CCol md={2}>
                          <CInputGroup>
                            <label>Is Officer?</label>
                            <WidgetSelector
                              options={YesNoOptions}
                              onChange={(values) => setIsOfficer(values.value)}
                              selectedValue={isOfficer}
                            />
                            {errors.branch_id && <ErrorMessage messages={errors.branch_id} />}
                          </CInputGroup>
                        </CCol> */}
                    <CCol md={3}>
                      <CButton
                        color="warning"
                        className="text-white"
                        onClick={() => setIsMore(!isMore)}
                        style={{ marginBottom: '20px', marginTop: '20px', marginLeft: '1%' }}
                      >
                        More
                      </CButton>
                      <CButton
                        color="primary"
                        onClick={() => getReportData()}
                        style={{ marginBottom: '20px', marginTop: '20px', marginLeft: '1%' }}
                      >
                        Search
                      </CButton>
                      {Base.hasRights('Export Employee Leave Report') && (
                        <CButton
                          color="success"
                          onClick={onDownload}
                          style={{ marginBottom: '20px', marginTop: '20px', marginLeft: '1%' }}
                          className="text-white"
                        >
                          Export
                        </CButton>
                      )}
                      {Base.hasRights('Print Employee Leave Report') && (
                        <CButton
                          color="danger"
                          className="text-white"
                          style={{ marginBottom: '20px', marginTop: '20px', marginLeft: '1%' }}
                          onClick={generatePDF}
                        >
                          PDF
                        </CButton>
                      )}
                    </CCol>
                  </CRow>
                  {isMore && (
                    <>
                      <CRow>
                        <CCol md={1}></CCol>
                        <CCol md={2}>
                          <CInputGroup>
                            <label>Designation</label>
                            <WidgetDesignationSelector
                              designations={designations}
                              displayValue={designation_name}
                              value={designation_id}
                              placeholder="Select Designation"
                              onChange={(values) => changeValues('designation_id', values)}
                              reloadDropdownData={() =>
                                Base.dropdownData('designations', {}, [setDesignations], 1)
                              }
                            />
                            {errors.designation_id && (
                              <ErrorMessage messages={errors.designation_id} />
                            )}
                          </CInputGroup>
                        </CCol>

                        <CCol md={2}>
                          <CInputGroup>
                            <label>Job Type:</label>
                            <WidgetSelector
                              options={JobTypeOptions}
                              placeHolder={'Please Select'}
                              selectedValue={JobType}
                              onChange={(values) => setJobType(values.value)}
                            />
                            {errors.job_status && <ErrorMessage messages={errors.job_status} />}
                          </CInputGroup>
                        </CCol>
                        <CCol md={2}>
                          <CInputGroup>
                            <label>Resignation Status</label>
                            <WidgetSelector
                              options={RESIGNATION_STATUS_DROPDOWN_OPTIONS}
                              placeHolder={'Please Select'}
                              selectedValue={ResignationStatus}
                              onChange={(values) => changeValues('resignation_status', values)}

                            />
                            {errors.resignation_status && <ErrorMessage messages={errors.resignation_status} />}
                          </CInputGroup>
                        </CCol>.
                        <CCol md={2}>
                          <CInputGroup>
                            <label>Parent Branch</label>
                            <WidgetBranchSelector
                              branches={branches}
                              displayValue={branch_name}
                              value={branchId}
                              placeholder="Select Branch"
                              onChange={(values) => changeValues('branch_id', values)}
                              reloadDropdownData={() =>
                                Base.dropdownData('branches', {}, [setBranches], 1)
                              }
                            />
                            {errors.branch_id && <ErrorMessage messages={errors.branch_id} />}
                          </CInputGroup>
                        </CCol>
                      </CRow>
                    </>
                  )}
                  <br />
                </CForm>
              </CCardBody>
            </CCard>
          </CCol>
        </CRow>
        <br />
        <br />
        {/* <AttendanceReportLegends /> */}
        <CRow>
          <CCol md={12}>
            <table className="table table-bordered data-table" ref={tableRef}>
              {isLoading ? (
                Loading
              ) : (
                <>
                  {reportData.length > 0 ? (
                    <LeaveReportDataTable
                      reportData={reportData}
                      leaveTypeData={leaveTypeData}
                      isOfficer={isOfficer}
                      setReportData={(data) => setReportData(data)}
                      isLoading={isLoading}
                      ref={tableRef}
                    />
                  ) : (
                    <center style={{ fontSize: '19px', fontWeight: 'bold' }}>
                      No record to show...
                    </center>
                  )}
                </>
              )}
            </table>
          </CCol>
        </CRow>
      </div>
    </>
  )
}
